import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CryptocurrencyFormFields } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/CryptocurrencyFormFields";
import { useCreateCryptocurrencyForm } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/useCreateCryptocurrencyForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateCryptocurrencyForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateCryptocurrencyForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<CryptocurrencyFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
